import { createAction } from '@reduxjs/toolkit';

const ACTION_PREFIX = 'organization';

export const toggleOrganizationEditMode = createAction(`${ACTION_PREFIX}/TOGGLE_ORGANIZATION_EDIT_MODE`);
export const redirectToCreditCard = createAction(`${ACTION_PREFIX}/REDIRECT_TO_CREDIT_CARD`);
export const resetRedirect = createAction(`${ACTION_PREFIX}/RESET_REDIRECT`);

export const editDetailsHandler = createAction(`${ACTION_PREFIX}/EDIT_DETAILS_HANDLER`);
export const editDetailsHandlerSucceeded = createAction(`${ACTION_PREFIX}/EDIT_DETAILS_HANDLER_SUCCEEDED`);
export const editDetailsHandlerFailed = createAction(`${ACTION_PREFIX}/EDIT_DETAILS_HANDLER_FAILED`);

export const setDetailsOnboarding = createAction(`${ACTION_PREFIX}/SET_DETAILS_ONBOARDING`);
export const setDetailsOnboardingSucceeded = createAction(`${ACTION_PREFIX}/SET_DETAILS_ONBOARDING_SUCCEEDED`);
export const setDetailsOnboardingFailed = createAction(`${ACTION_PREFIX}/SET_DETAILS_ONBOARDING_FAILED`);

export const editOrgDetailsHandler = createAction(`${ACTION_PREFIX}/EDIT_ORG_DETAILS_HANDLER`);
export const editOrgDetailsHandlerSucceeded = createAction(`${ACTION_PREFIX}/EDIT_ORG_DETAILS_HANDLER_SUCCEEDED`);
export const editOrgDetailsHandlerFailed = createAction(`${ACTION_PREFIX}/EDIT_ORG_DETAILS_HANDLER_FAILED`);

export const organizationDetailsFetch = createAction(`${ACTION_PREFIX}/FETCH_ORGANIZATION_DETAILS`);
export const organizationDetailsFetchSucceeded = createAction(`${ACTION_PREFIX}/FETCH_ORGANIZATION_DETAILS_SUCCEEDED`);
export const organizationDetailsFetchFailed = createAction(`${ACTION_PREFIX}/FETCH_ORGANIZATION_DETAILS_FAILED`);

export const forceGoogleLoginEnable = createAction(`${ACTION_PREFIX}/FORCE_GOOGLE_LOGIN_ENABLE`);
export const forceGoogleLoginEnableSucceeded = createAction(`${ACTION_PREFIX}/FORCE_GOOGLE_LOGIN_ENABLE_SUCCEEDED`);
export const forceGoogleLoginEnableFailed = createAction(`${ACTION_PREFIX}/FORCE_GOOGLE_LOGIN_ENABLE_FAILED`);

export const forceOidcLoginEnable = createAction(`${ACTION_PREFIX}/FORCE_OIDC_LOGIN_ENABLE`);
export const forceOidcLoginEnableSucceeded = createAction(`${ACTION_PREFIX}/FORCE_OIDC_LOGIN_ENABLE_SUCCEEDED`);
export const forceOidcLoginEnableFailed = createAction(`${ACTION_PREFIX}/FORCE_OIDC_LOGIN_ENABLE_FAILED`);

export const forceGoogleLoginDisable = createAction(`${ACTION_PREFIX}/FORCE_GOOGLE_LOGIN_DISABLE`);
export const forceGoogleLoginDisableSucceeded = createAction(`${ACTION_PREFIX}/FORCE_GOOGLE_LOGIN_DISABLE_SUCCEEDED`);
export const forceGoogleLoginDisableFailed = createAction(`${ACTION_PREFIX}/FORCE_GOOGLE_LOGIN_DISABLE_FAILED`);

export const forceOidcLoginDisable = createAction(`${ACTION_PREFIX}/FORCE_OIDC_LOGIN_DISABLE`);
export const forceOidcLoginDisableSucceeded = createAction(`${ACTION_PREFIX}/FORCE_OIDC_LOGIN_DISABLE_SUCCEEDED`);
export const forceOidcLoginDisableFailed = createAction(`${ACTION_PREFIX}/FORCE_OIDC_LOGIN_DISABLE_FAILED`);

export const ipWhitelistFetch = createAction(`${ACTION_PREFIX}/IP_WHITELIST_FETCH`);
export const ipWhitelistFetchSucceeded = createAction(`${ACTION_PREFIX}/IP_WHITELIST_FETCH_SUCCEEDED`);
export const ipWhitelistFetchFailed = createAction(`${ACTION_PREFIX}/IP_WHITELIST_FETCH_FAILED`);

export const OrganizationActions = {
  toggleOrganizationEditMode,
  redirectToCreditCard,
  resetRedirect,

  editDetailsHandler,
  editDetailsHandlerSucceeded,
  editDetailsHandlerFailed,

  setDetailsOnboarding,
  setDetailsOnboardingSucceeded,
  setDetailsOnboardingFailed,

  editOrgDetailsHandler,
  editOrgDetailsHandlerSucceeded,
  editOrgDetailsHandlerFailed,

  organizationDetailsFetch,
  organizationDetailsFetchSucceeded,
  organizationDetailsFetchFailed,

  ipWhitelistFetch,
  ipWhitelistFetchSucceeded,
  ipWhitelistFetchFailed,

  forceGoogleLoginEnable,
  forceGoogleLoginEnableSucceeded,
  forceGoogleLoginEnableFailed,

  forceGoogleLoginDisable,
  forceGoogleLoginDisableSucceeded,
  forceGoogleLoginDisableFailed,

  forceOidcLoginEnable,
  forceOidcLoginEnableSucceeded,
  forceOidcLoginEnableFailed,

  forceOidcLoginDisable,
  forceOidcLoginDisableFailed,
  forceOidcLoginDisableSucceeded,
};
